export default "__VITE_ASSET__B$xt29_D__"